import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { testIdPart } from "@/lib/testIds";

export const serviceReveal = {
  initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.75, ease: [0.16, 1, 0.3, 1] },
};

export const ServiceIllustration = ({ service, reverse }) => (
  <motion.div {...serviceReveal} transition={{ ...serviceReveal.transition, delay: 0.1 }} className={reverse ? "lg:order-2" : ""}>
    <div className="relative">
      <div aria-hidden="true" className="absolute -inset-2 rounded-3xl blur-2xl opacity-70" style={{ background: service.glow }} />
      <img src={service.image} alt={service.imageAlt} loading="lazy" className="clip-frame relative w-full aspect-[4/3] object-cover border" style={{ borderColor: `${service.color}66` }} data-testid={`service-image-${service.id}`} />
      <div className="absolute top-4 left-4 font-display text-5xl sm:text-6xl leading-none" style={{ color: service.color, textShadow: `0 0 24px ${service.glow}` }} data-testid={`service-number-${service.id}`}>{service.num}</div>
    </div>
  </motion.div>
);

export const ServiceDescription = ({ service }) => <>
  <p className="font-mono-ui text-[11px] uppercase tracking-[0.3em] mb-4" style={{ color: service.color }}>Service {service.num} — {service.title}</p>
  <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-none" data-testid={`service-title-${service.id}`}>{service.name}</h2>
  <p className="mt-3 text-lg font-semibold" style={{ color: service.color }}>{service.tagline}</p>
  <p className="mt-5 text-slate-300 text-base sm:text-lg leading-relaxed">{service.description}</p>
  <ul className="mt-6 flex flex-wrap gap-2">{service.tasks.map((task) => (
    <li key={task} className="px-3 py-1.5 rounded-full border text-xs sm:text-sm bg-panel/80" style={{ borderColor: `${service.color}55`, color: "#e2e8f0" }} data-testid={`service-task-${service.id}-${testIdPart(task)}`}>
      <span style={{ color: service.color }} className="mr-1.5" aria-hidden="true">●</span>{task}
    </li>
  ))}</ul>
</>;

export const ServiceActions = ({ service, onQuote, onAi }) => (
  <div className="mt-8 flex flex-wrap gap-4">
    <motion.button whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.96 }} onClick={() => onQuote(service)} className="px-7 py-4 rounded-full font-bold uppercase tracking-wide text-sm text-ink" style={{ background: service.color, boxShadow: `0 0 26px ${service.glow}` }} data-testid={`service-quote-button-${service.id}`}>{service.ctaLabel}</motion.button>
    {service.ai && <motion.button whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.96 }} onClick={onAi} className="px-7 py-4 rounded-full font-bold uppercase tracking-wide text-sm border flex items-center gap-2" style={{ borderColor: service.color, color: service.color }} data-testid={`service-ai-button-${service.id}`}>
      <Sparkles size={16} className="shrink-0" />Demander à l'IA d'imaginer votre chef-d'œuvre
    </motion.button>}
  </div>
);